module.exports = __webpack_public_path__ + "static/media/flag-blue.e65010be.gif";